import Papa from 'papaparse'

const BASE_URL = import.meta.env.BASE_URL || '/'

const DATA_FILES = {
  customers: `${BASE_URL}data/customers.csv`,
  monthlyArr: `${BASE_URL}data/monthly_arr.csv`,
  arrMovements: `${BASE_URL}data/arr_movements.csv`,
  deals: `${BASE_URL}data/deals.csv`,
  financialTargets: `${BASE_URL}data/financial_targets.csv`,
  onboarding: `${BASE_URL}data/onboarding.csv`
}

async function loadCSV(path) {
  const response = await fetch(path)
  if (!response.ok) {
    throw new Error(`Failed to load ${path}: ${response.statusText}`)
  }
  const text = await response.text()

  return new Promise((resolve, reject) => {
    Papa.parse(text, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: (results) => {
        if (results.errors.length > 0) {
          console.warn(`Parse warnings for ${path}:`, results.errors)
        }
        resolve(results.data)
      },
      error: (error) => {
        reject(error)
      }
    })
  })
}

export async function loadAllData() {
  const entries = Object.entries(DATA_FILES)

  const results = await Promise.all(
    entries.map(async ([key, path]) => {
      try {
        const data = await loadCSV(path)
        return [key, data]
      } catch (error) {
        console.error(`Error loading ${key}:`, error)
        return [key, []]
      }
    })
  )

  return Object.fromEntries(results)
}

export function getUniqueValues(data, field) {
  return [...new Set(data.map(item => item[field]).filter(Boolean))].sort()
}

export function filterByDateRange(data, dateField, startMonth, endMonth) {
  if (!startMonth && !endMonth) return data

  return data.filter(item => {
    const date = item[dateField]
    if (!date) return false
    if (startMonth && date < startMonth) return false
    if (endMonth && date > endMonth) return false
    return true
  })
}
